import 'css-chunksrc/client/scenes/projectCreationForm/secondaryCriteria/styles.scss';export default {
  "secondaryCriteria": "_secondaryCriteria_12rnr_1",
  "row": "_row_12rnr_9",
  "label": "_label_12rnr_14",
  "form": "_form_12rnr_25",
  "required": "_required_12rnr_33"
};